var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('./data/keys'),
    names = _require.names;

var rmrkToNameUnits = require('./utils/rmrkToNameUnits'); //Apply scale and matrix transformations to data


function interpretKLV(_x, _x2) {
  return _interpretKLV.apply(this, arguments);
}

function _interpretKLV() {
  _interpretKLV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(klv, options) {
    var result, toInterpret, someMatch, labels;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            try {
              result = JSON.parse(JSON.stringify(klv));
            } catch (e) {
              result = klv;
            }

            if (!(result != null && result.interpretSamples)) {
              _context.next = 19;
              break;
            }

            toInterpret = ['SCAL', 'altitudeFix', 'ORIN', 'ORIO', 'MTRX', 'TYPE'];

            someMatch = function someMatch(a1, a2) {
              var _iterator = _createForOfIteratorHelper(a1),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var elt = _step.value;
                  if (a2.includes(elt)) return true;
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              return false;
            }; //if there are keys to interpret


            if (!someMatch(toInterpret, Object.keys(result))) {
              _context.next = 9;
              break;
            }

            //set label based on transformation
            if (result.hasOwnProperty('ORIN') && result.hasOwnProperty('ORIO')) {
              if (typeof result.ORIO === 'string') result.ORIO = result.ORIO.split('');
              labels = "(".concat(result.ORIO.map(function (o) {
                return o.toLowerCase();
              }).join(','), ")");
              if (result.STNM) result.STNM += " ".concat(labels);else result.STNM = labels;
            } //Loop through the samples to interpret them


            result[result.interpretSamples] = result[result.interpretSamples].map(function (s) {
              //Avoid operations on null samples
              if (s == null) return s; //If scaling data

              if (result.hasOwnProperty('SCAL')) {
                //If single value, scale, otherwise loop through array
                if (typeof s === 'number') s = s / result.SCAL;else if (Array.isArray(s)) {
                  //If scaling is array, apply to each "axis", otherwise apply to all
                  if (result.SCAL.length === s.length) s = s.map(function (ss, i) {
                    return typeof ss === 'number' ? ss / result.SCAL[i] : ss;
                  });else s = s.map(function (ss) {
                    return typeof ss === 'number' ? ss / result.SCAL : ss;
                  });
                }
              } //Fix altitude


              if (result.hasOwnProperty('altitudeFix') && result.GPS5 && s && s.length > 2) s[2] = s[2] - result.altitudeFix;

              if (result.hasOwnProperty('ORIN') && result.hasOwnProperty('ORIO')) {
                //Transform with this if no matrix present, otherwise will transform with matrix later
                if (!result.hasOwnProperty('MTRX')) {
                  var newS = [];
                  var len = result.ORIN.length;

                  for (var y = 0; y < len; y++) {
                    for (var x = 0; x < len; x++) {
                      if (result.ORIN[y].toUpperCase() === result.ORIO[x]) {
                        if (result.ORIN[y] === result.ORIO[x]) newS[x] = s[y];else newS[x] = -s[y];
                      }
                    }
                  }

                  s = newS;
                }
              }

              if (result.hasOwnProperty('MTRX')) {
                //Transform axis, including potential calibration data
                var _newS = [];

                var _len = Math.sqrt(result.MTRX.length);

                for (var _y = 0; _y < _len; _y++) {
                  for (var _x3 = 0; _x3 < _len; _x3++) {
                    if (result.MTRX[_y * _len + _x3] !== 0) _newS[_x3] = s[_y] * result.MTRX[_y * _len + _x3];
                  }
                }

                s = _newS;
              } //Add name and units if missing and possible


              var rmrkName, rmrkUnits;

              if (result.RMRK && /^struct: (.*)/.test(result.RMRK)) {
                var _rmrkToNameUnits = rmrkToNameUnits(result.RMRK),
                    name = _rmrkToNameUnits.name,
                    units = _rmrkToNameUnits.units;

                rmrkName = name;
                rmrkUnits = units;
              }

              if (!result.hasOwnProperty('STNM')) {
                if (names[result.interpretSamples]) {
                  result.STNM = names[result.interpretSamples];
                } else if (rmrkName) result.STNM = rmrkName;
              }

              if (!result.hasOwnProperty('UNIT') && rmrkUnits) result.UNIT = rmrkUnits;
              return s;
            }); //If we did not interpret, look deeper

            _context.next = 18;
            break;

          case 9:
            if (!Array.isArray(result[result.interpretSamples])) {
              _context.next = 15;
              break;
            }

            _context.next = 12;
            return Promise.all(result[result.interpretSamples].map(function (s) {
              return interpretKLV(s, options);
            }));

          case 12:
            result[result.interpretSamples] = _context.sent;
            _context.next = 18;
            break;

          case 15:
            _context.next = 17;
            return interpretKLV(result[result.interpretSamples], options);

          case 17:
            result[result.interpretSamples] = _context.sent;

          case 18:
            toInterpret.forEach(function (k) {
              return delete result[k];
            });

          case 19:
            return _context.abrupt("return", result);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _interpretKLV.apply(this, arguments);
}

module.exports = interpretKLV;